<template>
  <v-row>
    <v-col cols="12" sm="12" md="5">
      <highcharts :options="options_left" ref="leftChart" />
    </v-col>
    <v-spacer />
    <v-col cols="12" sm="12" md="5">
      <highcharts :options="options_right" ref="rightChart" />
    </v-col>
  </v-row>
</template>

<script>
import NoChartData from './TheNoChartData'
export default {
  name: 'HorizontalDoubleBarChart',
  components: {NoChartData},
  data () {
    return {
      options_left: {
        chart: {
          type: 'bar',
          style: { color: 'black', fontFamily: "Roboto, sans-serif", fontWeight: 'normal', textShadow: 'none' }
          // width: 500
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            enabled: false
          },
          labels: {
            overflow: 'justify'
          }
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          data: []
        }]
      },
      options_right: {
        chart: {
          type: 'bar',
          style: { color: 'black', fontFamily: "Roboto, sans-serif", fontWeight: 'normal', textShadow: 'none' }
          // width: 500
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            enabled: false
          },
          labels: {
            overflow: 'justify'
          }
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          bar: {
            dataLabels: {
              // eslint-disable-next-line
              format: '${point.y:,.2f}',
              enabled: true
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          data: []
        }]
      }
    }
  },
  props: {
    leftChartData: {
      type: Object,
      default: () => {}
    },
    rightChartData: {
      type: Object,
      default: () => {}
    },
    leftMetric: {
      type: String,
      default: () => {}
    },
    rightMetric: {
      type: String,
      default: () => {}
    }
  },
  created () {
    this.options_right.xAxis.categories = this.rightChartData.metrics
    this.options_left.xAxis.categories = this.leftChartData.metrics
    this.options_left.series[0].data = this.leftChartData.data
    this.options_right.series[0].data = this.addBarsColor(this.rightChartData.data)
    // Note: set formatter
    if (this.leftMetric === 'reach') this.options_left.plotOptions.bar.dataLabels.format = '{point.y:,.f}'
    // eslint-disable-next-line
    else this.options_left.plotOptions.bar.dataLabels.format = '${point.y:,.2f}'
  },
  methods: {
    getBarColor (value) {
      const colors = [
        {
          value: 1.5,
          hash: '#86BCBC'
        },
        {
          value: 2,
          hash: '#81b2eb'
        }
      ]
      const color = colors.find(color => value < color.value)
      return color ? color.hash : '#E17365'
    },
    addBarsColor (array) {
      return array.map(value => {
        return {
          y: value,
          color: this.getBarColor(value)
        }
      })
    }
  },
  watch: {
    leftChartData (val) {
      const leftChart = this.$refs.leftChart.chart
      this.options_left.xAxis.categories = val.metrics
      this.options_left.series[0].data = val.data
      if (this.leftMetric === 'reach') this.options_left.plotOptions.bar.dataLabels.format = '{point.y:,.f}'
      // eslint-disable-next-line
      else this.options_left.plotOptions.bar.dataLabels.format = '${point.y:,.2f}'
      leftChart.redraw()
    },
    rightChartData (val) {
      const rightChart = this.$refs.rightChart.chart
      this.options_right.xAxis.categories = val.metrics
      this.options_right.series[0].data = this.addBarsColor(val.data)
      rightChart.redraw()
    }
  }
}
</script>
